import store_fiche from "@/store/mods/consultations/fiche-consultations"
import $ from 'jquery'

export default {
    name: 'choix-fiche-consultation',
    components: {},
    props: {
        fiche_toggler: Number,
        info_consultation: {
            type: Object,
            default: () => ({})
        },
        sections: {
            type: Array,
            default: () => ([])
        },
        user_id: {
            type: Number,
            default: () => (0)
        },
        user_info: {
            type: Object,
            default: () => ({})
        }
    },

    watch: {
        fiche_toggler() {
            this.err_message = ''
            this.is_confirm = false
            this.getGroupedFicheConnsultationByTypeConsultation()
        }
    },

    data() {
        return {
            groued_fiches_consultations: [],
            fiche_loading: true,
            fiche_empty: false,
            curr_fiche: 0,
            save_loading: false,


            is_confirm: false,
            is_error: false,
            err_message: ''
        }
    },

    computed: {

    },

    mounted() {
        Array.prototype.groupBy = function (key) {
            return this
                .reduce((hash, obj) => {
                    if (obj[key] === undefined) return hash;
                    return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
                }, {})
        };
    },

    methods: {
        getGroupedFicheConnsultationByTypeConsultation() {
            this.fiche_loading = true
            store_fiche.getGroupedFicheConsultation().then((response) => {
                const tmp_fiches_consultations = response

                if (tmp_fiches_consultations.length == 0) {
                    this.groued_fiches_consultations = tmp_fiches_consultations
                    this.fiche_empty = true
                } else {
                    this.fiche_empty = false

                    this.groued_fiches_consultations = []

                    const tmp_grouped_fiches = tmp_fiches_consultations.groupBy('type_consultation')

                    for (const key in tmp_grouped_fiches) {
                        const tmp_group = {
                            type_consultation: (key != 'null')?key:'Fiche standard',
                            fiches: tmp_grouped_fiches[key]
                        }
                        this.groued_fiches_consultations.push(tmp_group)
                    }
                    
                    
                }
                this.fiche_loading = false
            })
        }, 

        saveChoice() {
            const data = {
                fiche_id: this.curr_fiche
            }

            this.$emit('emitRefreshFiche', data)
            this.$refs.brwse_fiche.click()
        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
         onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        confirmStart(selector) {
            this.err_message = ''
            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé
                $('.err-msg').fadeIn(500)
                return
            }

            let data = {
                fiche_id: this.info_consultation.fiche_id,
                user_id: this.user_id,
                user_info: this.user_info,
                consultation_id: this.info_consultation.consultation_id,
                evolution_id: this.info_consultation.evolution_id,
                sections: this.sections
            }
            
            this.save_loading = true
            store_fiche.startConsultation(data).then((response) => {
                if (response.success) {
                    this.$refs.strt_consultation.click()
                    this.successToast(response.message)

                    this.$emit('emitRefreshConsultation')
                } else {
                    this.err_message = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.$refs.strt_consultation.click()
                this.save_loading = false
                this.errorToast("Une erreur s'est produite !")
            })
        }
    }
}